import { Button, Size } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('live_updates.overview.status')
const tDisabled = buildTranslate('live_updates.overview.setup_disabled')

export interface SetupDisabledCardProps {
  onTurnOn?: () => void
}

const SetupDisabledCard = ({ onTurnOn }: SetupDisabledCardProps) => {
  const [css] = useStyletron()

  return (
    <div data-testid="lu-overview-setup-disabled">
      <Text.Header3
        tag="h2"
        className={css({ margin: '0 0 18px', paddingTop: '8px' })}
      >
        {t('preview_title')}
      </Text.Header3>
      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          padding: '24px',
          borderRadius: '12px',
          backgroundColor: palette.white,
          border: `1px solid ${palette.grey30}`,
        })}
      >
        <span
          aria-hidden="true"
          className={css({
            display: 'flex',
            flexShrink: 0,
            color: palette.grey50,
          })}
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect x="2" y="6" width="20" height="12" rx="6" />
            <circle cx="8" cy="12" r="2.5" fill="currentColor" stroke="none" />
          </svg>
        </span>
        <div className={css({ flex: '1 1 auto' })}>
          <Text.Header4 tag="h3" className="m-0">
            {tDisabled('title')}
          </Text.Header4>
          <Text.BodyText3 color="grey70" className="mt-xs">
            {tDisabled('body')}
          </Text.BodyText3>
        </div>
        {onTurnOn && (
          <Button size={Size.STANDARD} onClick={onTurnOn}>
            {tDisabled('turn_on')}
          </Button>
        )}
      </div>
    </div>
  )
}

export default SetupDisabledCard
